import * as React from 'react'
import {
  GridColumnMenuSort,
  GridColumnMenuFilter,
  GridColumnMenuItemGroup,
} from '@progress/kendo-react-grid'
export class ColumnMenu extends React.Component {
  state = {
    columns: this.props.columns,
    columnsExpanded: false,
    filterExpanded: false,
    resetColumnsExpanded: false,
  }
  onFilterExpandChange = (value) => {
    this.setState({
      filterExpanded: value,
      columnsExpanded: value ? false : this.state.columnsExpanded,
      resetColumnsExpanded: false,
    })
  }
  render() {
    return (
      <div>
        {this.props.column?.field !== 'caseids' &&
          this.props.column?.field !== '' && (
            <GridColumnMenuSort {...this.props} />
          )}
        {this.props.column?.field !== 'caseids' &&
          this.props.column?.field !== '' && (
            <GridColumnMenuFilter
              {...this.props}
              onExpandChange={this.onFilterExpandChange}
              expanded={this.state.filterExpanded}
            />
          )}
        <GridColumnMenuItemGroup>
        </GridColumnMenuItemGroup>
      </div>
    )
  }
}
